// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileIconChat__primary-color-c8ca97 {
  fill: var(--file-ic-primary-color);
}

.FileIconChat__secondary-color-cc182c {
  fill: var(--file-ic-secondary-color);
}

.FileIconChat__progress-cb9d75,
.FileIconChat__infinity-f2efed {
  stroke: var(--file-ic-secondary-color);
  stroke-linecap: round;
  fill: transparent;
  transform-box: fill-box;
  transform-origin: center;
  stroke-width: 2px;
}

.FileIconChat__progress-cb9d75 {
  transform: rotate(-90deg);
  stroke-dasharray: 100;
}

.FileIconChat__infinity-f2efed {
  animation: FileIconChat__dash-f8ff66 1.5s ease-in-out infinite, FileIconChat__rotate-d15250 2s linear infinite;
}

.FileIconChat__pointer-a7ca01 {
  cursor: pointer;
}

@keyframes FileIconChat__rotate-d15250 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes FileIconChat__dash-f8ff66 {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/FileIcon/FileIconChat/FileIconChat.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;;EAEE,sCAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,8GAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,wBAAA;IACA,oBAAA;EAAF;EAEA;IACE,yBAAA;IACA,sBAAA;EAAF;EAEA;IACE,yBAAA;IACA,uBAAA;EAAF;AACF","sourcesContent":[".primary-color {\n  fill: var(--file-ic-primary-color);\n}\n\n.secondary-color {\n  fill: var(--file-ic-secondary-color);\n}\n\n.progress,\n.infinity {\n  stroke: var(--file-ic-secondary-color);\n  stroke-linecap: round;\n  fill: transparent;\n  transform-box: fill-box;\n  transform-origin: center;\n  stroke-width: 2px;\n}\n\n.progress {\n  transform: rotate(-90deg);\n  stroke-dasharray: 100;\n}\n\n.infinity {\n  animation: dash 1.5s ease-in-out infinite, rotate 2s linear infinite;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-color": `FileIconChat__primary-color-c8ca97`,
	"primaryColor": `FileIconChat__primary-color-c8ca97`,
	"secondary-color": `FileIconChat__secondary-color-cc182c`,
	"secondaryColor": `FileIconChat__secondary-color-cc182c`,
	"progress": `FileIconChat__progress-cb9d75`,
	"infinity": `FileIconChat__infinity-f2efed`,
	"dash": `FileIconChat__dash-f8ff66`,
	"rotate": `FileIconChat__rotate-d15250`,
	"pointer": `FileIconChat__pointer-a7ca01`
};
module.exports = ___CSS_LOADER_EXPORT___;
